import React from 'react'
import './../App.css'
import X46MK2Hull from './X46MK2Hull'
import X46MK2AllExteriorOptions from './X46MK2AllExteriorOptions'
import { Route, Switch, Redirect } from 'react-router-dom'
import X46MK2BowSprit from './X46MK2BowSprit'
import X46MK2HullTreatment from './X46MK2HullTreatment'
import X46MK2Transom from './X46MK2Transom'
import X46MK2Deck from './X46MK2Deck'
import X46MK2Cockpit from './X46MK2Cockpit'
import X46MK2Sprayhood from './X46MK2Sprayhood'
import X46MK2Wheel from './X46MK2Wheel'
import X46MK2Mast from './X46MK2Mast'
import X46MK2Interior from './X46MK2Interior'
import X46MK2Galley from './X46MK2Galley'
import X46MK2Fabric from './X46MK2Fabric'
import X46MK2Saloon from './X46MK2Saloon'
import X46MK2OwnersCabin from './X46MK2OwnersCabin'
import X46MK2Heads from './X46MK2Heads'
import X46MK2AftCabin from './X46MK2AftCabin'
import X46MK2StarboardAftCabin from './X46MK2StarboardAftCabin'
import Logo from './X46MK2-logo.svg'
import X46MK2Summary from './X46MK2Summary'
import X46MK2BathingPlatform from './X46MK2BathingPlatform'

import hullColor11 from '../assets/hullColors/Hull colour -  pure white RAL 9010 & 3 x light grey RAL 7035 waterliness.jpg'
import hullColor12 from '../assets/hullColors/Hull colour -  pure white RAL 9010 & 3 x black grey RAL 702 waterlines.jpg'
import hullColor13 from '../assets/hullColors/Hull colour -  pure white RAL 9010 & 3 x dark blue RAL 5011 waterlines.jpg'
import hullColor14 from '../assets/hullColors/Hull colour - light grey RAL 7035 & 3 x pure white RAL 9010 waterlines.jpg'
import hullColor15 from '../assets/hullColors/Hull colour - black grey RAL 7021 & 3 x pure white RAL 9010 waterlines.jpg'

import fabric1 from '../assets/fabrics/JustFleckless–01Nature.jpg'
import fabric2 from '../assets/fabrics/JustFleckless–05Camel.jpg'
import fabric3 from '../assets/fabrics/JustFleckless–10Navy.jpg'
import fabric4 from '../assets/fabrics/JustFleckless–403Bambus.jpg'
import fabric5 from '../assets/fabrics/JustFleckless–710MoonGrey.jpg'
import fabric6 from '../assets/fabrics/JustFleckless–750OliveGrey.jpg'
import fabric7 from '../assets/fabrics/AlsaceBlue.jpg'
import fabric8 from '../assets/fabrics/AlsaceIvory.jpg'
import fabric9 from '../assets/fabrics/AlsaceSand.jpg'
import fabric10 from '../assets/fabrics/Nubilux709Argent.jpg'

import galley1 from '../assets/galleyColors/camoan_white_corian.jpg'
import galley2 from '../assets/galleyColors/black_quartz_corian.jpg'

import veneer1 from '../assets/interiorColors/nordic_oak.jpg'
import veneer2 from '../assets/interiorColors/teak.jpg'

import laminate1 from '../assets/interiorColors/teak_without_koto.jpg'
import laminate2 from '../assets/interiorColors/walnut.jpg'
import laminate3 from '../assets/interiorColors/teak_with_koto.jpg'

import sprayhood1 from '../assets/sprayhoodColors/without.jpg'
import sprayhood2 from '../assets/sprayhoodColors/Dark grey.jpg'
import sprayhood3 from '../assets/sprayhoodColors/Taupe.jpg'
import sprayhood4 from '../assets/sprayhoodColors/Captains blue.jpg'
import sprayhood5 from '../assets/sprayhoodColors/Silver grey.jpg'

import deckOption1 from '../assets/deck/modernteak.jpg'
import deckOption2 from '../assets/deck/flexiteek.jpg'

import ConfiguratorContainer from '../ConfiguratorContainer'
import { withTranslation } from 'react-i18next'
import { normalizeX46MK2InteriorConfiguration } from './X46MK2RenderConfiguration'

class X46MK2Container extends ConfiguratorContainer {
  constructor (props) {
    super(props)

    this.logo = Logo
    this.logoLink = 'https://www.x-yachts.com/en/yachts/x/x4-6-mk-ii/'

    this.HullColourOptions = [
      {
        value: 1,
        label: this.props.t('Pure White'),
        description: this.props.t(
          '(RAL 9010) & 3 x Light Grey (RAL 7035) integrated Gelcoat Water Lines'
        ),
        preview: hullColor11
      },
      {
        value: 2,
        label: this.props.t('Pure White'),
        description: this.props.t(
          '(RAL 9010) & 3 x Black Grey (RAL 7021) integrated Gelcoat Water Lines'
        ),
        preview: hullColor12
      },
      {
        value: 3,
        label: this.props.t('Pure White'),
        description: this.props.t(
          '(RAL 9010) & 3 x Dark Blue (RAL 5011) integrated Gelcoat Water Lines'
        ),
        preview: hullColor13
      },
      {
        value: 4,
        label: this.props.t('Light Grey'),
        description: this.props.t(
          '(RAL 7035) & 3 x Pure White (RAL 9010) integrated Gelcoat Water Lines'
        ),
        preview: hullColor14
      },
      {
        value: 5,
        label: this.props.t('Black Grey'),
        description: this.props.t(
          '(RAL 7021) & 3 x Pure White (RAL 9010) integrated Gelcoat Water Lines'
        ),
        preview: hullColor15
      }
    ]

    this.BowSpritOptions = [
      {
        value: 1,
        label: this.props.t('None'),
        description: this.props.t('(without bowsprit)')
      },
      {
        value: 2,
        label: this.props.t('Bowsprit railing and bowsprit ladder')
      }
    ]

    this.HullTreatmentOptions = [
      { value: 1, label: this.props.t('White') },
      { value: 2, label: this.props.t('Gray') },
      { value: 3, label: this.props.t('Black') },
      { value: 4, label: this.props.t('Copper') }
    ]

    this.DeckOptions = [
      {
        value: 1,
        label: this.props.t('Genuine teak with black caulkings'),
        preview: deckOption1
      },
      {
        value: 2,
        label: this.props.t('Flexiteek with grey stripes'),
        preview: deckOption2
      }
    ]

    this.SideDeckOptions = [
      { value: 1, label: this.props.t('Off') },
      { value: 2, label: this.props.t('On') }
    ]

    this.TeakOnSideDecksOptions = this.SideDeckOptions

    this.BathingPlatformOptions = [
      { value: 1, label: this.props.t('None') },
      { value: 2, label: this.props.t('Off') },
      { value: 3, label: this.props.t('On') }
    ]

    this.SelfTackerOptions = [
      { value: 1, label: this.props.t('No selftacker') },
      { value: 2, label: this.props.t('Selftacking track recessed') }
    ]

    this.TeakOnCoachRoofOptions = [
      { value: 1, label: this.props.t('Off') },
      { value: 2, label: this.props.t('On') },
      { value: 3, label: this.props.t('On with cutout') }
    ]

    this.SprayhoodOptions = [
      { value: 1, label: this.props.t('Without'), thumbnail: sprayhood1 },
      { value: 2, label: this.props.t('Dark grey'), thumbnail: sprayhood2 },
      { value: 3, label: this.props.t('Taupe'), thumbnail: sprayhood3 },
      { value: 4, label: this.props.t('Captains blue'), thumbnail: sprayhood4 },
      { value: 5, label: this.props.t('Silver grey'), thumbnail: sprayhood5 }
    ]
    this.WheelOptions = [
      { value: 1, label: this.props.t('Steel wheel') },
      { value: 2, label: this.props.t('Composite wheel black') },
      { value: 3, label: this.props.t('Composite wheel white') }
    ]

    this.BoomCoverOptions = this.SprayhoodOptions

    this.MastAndBoomOptions = [
      { value: 1, label: this.props.t('Aluminium') },
      { value: 2, label: this.props.t('Clear coated carbon') },
      { value: 3, label: this.props.t('White painted carbon') },
      { value: 4, label: this.props.t('Black painted carbon') }
    ]

    this.OutboardBracketOptions = [
      { value: 1, label: this.props.t('Off') },
      { value: 2, label: this.props.t('On') }
    ]

    this.CockpitBenchExtentionsOptions = [
      { value: 1, label: this.props.t('Standard') },
      { value: 2, label: this.props.t('Extended') }
    ]

    this.CockpitCushionBackrestsOptions = [
      { value: 1, label: this.props.t('Off') },
      { value: 2, label: this.props.t('On') }
    ]

    this.CockpitCushionSeatsOptions = [
      { value: 1, label: this.props.t('Off') },
      { value: 2, label: this.props.t('On') }
    ]

    this.GTSeatOptions = [
      { value: 1, label: this.props.t('Off') },
      { value: 2, label: this.props.t('On') },
      { value: 3, label: this.props.t('On with cushion') }
    ]

    this.CockpitFabricOptions = [
      {
        value: 1,
        label: this.props.t('Just Fleckless - 01 Nature'),
        thumbnail: fabric1
      },
      {
        value: 2,
        label: this.props.t('Just Fleckless - 05 Camel'),
        thumbnail: fabric2
      },
      {
        value: 3,
        label: this.props.t('Just Fleckless - 10 Navy'),
        thumbnail: fabric3
      },
      {
        value: 4,
        label: this.props.t('Just Fleckless - 403 Bambus'),
        thumbnail: fabric4
      },
      {
        value: 5,
        label: this.props.t('Just Fleckless - 710 Moon Grey'),
        thumbnail: fabric5
      },
      {
        value: 6,
        label: this.props.t('Just Fleckless - 750 Olive Grey'),
        thumbnail: fabric6
      },
      { value: 7, label: this.props.t('Alsace Blue'), thumbnail: fabric7 },
      { value: 8, label: this.props.t('Alsace Ivory'), thumbnail: fabric8 },
      { value: 9, label: this.props.t('Alsace Sand'), thumbnail: fabric9 },
      {
        value: 10,
        label: this.props.t('Nubilux 709 Argent'),
        thumbnail: fabric10
      }
    ]

    this.FlagOptions = [{ value: 1, label: this.props.t('danish YF flag') }]

    this.VeneerOptions = [
      {
        value: 1,
        label: this.props.t('Nordic oak (standard)'),
        thumbnail: veneer1
      },
      {
        value: 2,
        label: this.props.t('Modern teak (optional)'),
        thumbnail: veneer2
      }
    ]

    this.FloorboardOptions = [
      {
        value: 1,
        label: this.props.t('Teak laminate (standard)'),
        thumbnail: laminate1
      },
      {
        value: 2,
        label: this.props.t('Walnut laminate (optional)'),
        thumbnail: laminate2
      },
      {
        value: 3,
        label: this.props.t('Teak with inlay stripes / holly (optional)'),
        thumbnail: laminate3
      }
    ]

    this.WorktopOptions = [
      {
        value: 1,
        label: this.props.t('Worktop in Camoan white Corian'),
        thumbnail: galley1
      },
      {
        value: 2,
        label: this.props.t('Worktop in black quartz Corian'),
        thumbnail: galley2
      }
    ]

    this.FabricSaloonOptions = [
      {
        value: 1,
        label: this.props.t('Just Fleckless – 01 Nature'),
        thumbnail: fabric1
      },
      {
        value: 2,
        label: this.props.t('Just Fleckless – 05 Camel'),
        thumbnail: fabric2
      },
      {
        value: 3,
        label: this.props.t('Just Fleckless – 10 Navy'),
        thumbnail: fabric3
      },
      {
        value: 4,
        label: this.props.t('Just Fleckless – 403 Bambus'),
        thumbnail: fabric4
      },
      {
        value: 5,
        label: this.props.t('Just Fleckless – 710 Moon Grey'),
        thumbnail: fabric5
      },
      {
        value: 6,
        label: this.props.t('Just Fleckless – 750 Olive Grey'),
        thumbnail: fabric6
      },
      { value: 7, label: this.props.t('Alsace Blue'), thumbnail: fabric7 },
      { value: 8, label: this.props.t('Alsace Ivory'), thumbnail: fabric8 },
      { value: 9, label: this.props.t('Alsace Sand'), thumbnail: fabric9 },
      {
        value: 10,
        label: this.props.t('Nubilux 709 Argent'),
        thumbnail: fabric10
      }
    ]

    this.FabricCabinsOptions = this.FabricSaloonOptions

    this.PortAftCabinOptions = [
      { value: 1, label: this.props.t('None') },
      { value: 2, label: this.props.t('Shelf') },
      { value: 3, label: this.props.t('Sea berth') }
    ]

    this.StarboardAftCabinOptions = [
      { value: 1, label: this.props.t('None') },
      { value: 2, label: this.props.t('Shelf') },
      { value: 3, label: this.props.t('Sea berth') }
    ]

    this.CupboardsOwnersCabinOptions = [
      { value: 1, label: this.props.t('Off') },
      { value: 2, label: this.props.t('On') }
    ]

    this.MastOptions = this.MastAndBoomOptions

    this.StarboardAftCabinBerthOptions = [
      {
        value: 1,
        label: this.props.t('Double berth'),
        description: this.props.t(' (standard) ')
      },
      {
        value: 2,
        label: this.props.t('Split berth'),
        description: this.props.t('(optional)')
      }
    ]

    this.TableBoxOptions = [
      { value: 1, label: this.props.t('Off') },
      { value: 2, label: this.props.t('On') }
    ]

    this.PouffesOptions = [
      { value: 1, label: this.props.t('Off') },
      { value: 2, label: this.props.t('On') }
    ]

    const defaultHullColour = this.HullColourOptions[0]
    const defaultTransomColor = this.getTransomColorByHullColourValue(
      defaultHullColour.value
    )

    this.state = Object.assign(this.state, {
      boat: 'X46MK2',
      exterior: {
        HullColorways: defaultHullColour,
        Bowsprit: this.BowSpritOptions[0],
        HullTreatment: this.HullTreatmentOptions[0],
        TeakDeck: this.DeckOptions[0],
        TeakOnSideDecks: { value: 1, label: 'false' },
        BathingPlatform: this.BathingPlatformOptions[1],
        SelfTacker: this.SelfTackerOptions[0],
        TeakOnCoachRoof: this.TeakOnCoachRoofOptions[0],
        Wheel: this.WheelOptions[0],
        MastAndBoom: this.MastAndBoomOptions[0],
        BoomCover: this.BoomCoverOptions[0],
        OutboardBracket: this.OutboardBracketOptions[0],
        CockpitBenchExtentions: this.CockpitBenchExtentionsOptions[0],
        CockpitCushionBackrests: this.CockpitCushionBackrestsOptions[0],
        CockpitCushionSeats: this.CockpitCushionSeatsOptions[0],
        CockpitFabric: this.CockpitFabricOptions[0],
        SprayhoodFabric: this.SprayhoodOptions[0],
        GTSeat: this.GTSeatOptions[0],
        Flag: this.FlagOptions[0]
      },
      transom: {
        Name: {
          verticalOffset: 150,
          color: defaultTransomColor,
          value: 'My yacht',
          font: this.fontOptions[0],
          size: this.sizeOptions[4],
          horizontalOffset: 0
        },
        Port: {
          verticalOffset: 380,
          color: defaultTransomColor,
          value: 'Port',
          font: this.fontOptions[0],
          size: this.sizeOptions[2],
          horizontalOffset: 0
        }
      },
      interior: {
        PortAftCabinOptions: this.PortAftCabinOptions[0],
        StarboardAftCabinOptions: this.StarboardAftCabinOptions[0],
        Veneer: this.VeneerOptions[0],
        Floorboard: this.FloorboardOptions[0],
        Worktop: this.WorktopOptions[0],
        StarboardAftCabin: this.StarboardAftCabinBerthOptions[0],
        FabricSaloon: this.FabricSaloonOptions[0],
        CupboardsOwnersCabin: { value: 1, label: 'false' },
        Mast: this.MastAndBoomOptions[0],
        TableBox: { value: 1, label: 'false' },
        Pouffes: { value: 1, label: 'false' },
        FabricCabins: this.FabricCabinsOptions[0]
      }
    })

    this.steps = [
      { name: this.props.t('Hull colourways'), url: '/x46mk2/hull' },
      { name: this.props.t('Bowsprit'), url: '/x46mk2/bowsprit' },
      { name: this.props.t('Hull treatment'), url: '/x46mk2/hulltreatment' },
      { name: this.props.t('Deck'), url: '/x46mk2/deck' },
      {
        name: this.props.t('Bathing platform'),
        url: '/x46mk2/bathingplatform'
      },
      { name: this.props.t('Boat name'), url: '/x46mk2/transom' },
      { name: this.props.t('Mast and boom'), url: '/x46mk2/mast' },
      { name: this.props.t('Wheels'), url: '/x46mk2/wheel' },
      { name: this.props.t('Cockpit'), url: '/x46mk2/cockpit' },
      {
        name: this.props.t('Sprayhood & Boom Cover'),
        url: '/x46mk2/sprayhood'
      },

      { name: this.props.t('Interior surfaces'), url: '/x46mk2/surfaces' },
      { name: this.props.t('Saloon furniture'), url: '/x46mk2/saloon' },
      { name: this.props.t('Interior Fabric'), url: '/x46mk2/fabric' },
      { name: this.props.t('Galley'), url: '/x46mk2/galley' },
      { name: this.props.t("Owner's cabin"), url: '/x46mk2/ownerscabin' },
      { name: this.props.t('Heads'), url: '/x46mk2/heads' },
      { name: this.props.t('Port aft cabin'), url: '/x46mk2/aftcabin' },
      {
        name: this.props.t('Starboard aft cabin'),
        url: '/x46mk2/starboardaftcabin'
      },

      { name: this.props.t('Summary'), url: '/x46mk2/summary' }
    ]

    this.handleHullConfigurationChange =
      this.handleHullConfigurationChange.bind(this)
    this.handleExteriorConfigurationChange =
      this.handleExteriorConfigurationChange.bind(this)
  }

  handleExteriorConfigurationChange (newConfiguration) {
    if (
      newConfiguration.BathingPlatform &&
      newConfiguration.BathingPlatform.value !== 3
    ) {
      newConfiguration = {
        ...newConfiguration,
        BathingPlatform:
          this.BathingPlatformOptions.find(v => v.value === 2) ||
          this.BathingPlatformOptions[1]
      }
    }

    let interior = this.state.interior
    interior.Mast = newConfiguration.MastAndBoom

    super.handleInteriorConfigurationChange(interior)
    super.handleExteriorConfigurationChange(newConfiguration)
  }

  handleHullConfigurationChange (newConfiguration) {
    let transom = this.state.transom
    const transomColor = this.getTransomColorByHullColourValue(
      newConfiguration.HullColorways.value
    )
    transom.Name.color = transomColor
    transom.Port.color = transomColor

    super.handleTransomChange(transom)
    this.handleExteriorConfigurationChange(newConfiguration)
  }

  getTransomColorByHullColourValue (hullColourValue) {
    if (hullColourValue === 4 || hullColourValue === 5) {
      return this.colorOptions[1]
    }

    return this.colorOptions[4]
  }

  migrateBathingPlatformValue (value) {
    const numericValue = +value || 2
    if (numericValue === 3) {
      return 3
    }
    return 2
  }

  getBathingPlatformCodeValue (bathingPlatform) {
    const value =
      bathingPlatform && typeof bathingPlatform.value !== 'undefined'
        ? bathingPlatform.value
        : 2
    return value === 3 ? 3 : 2
  }

  migrateBowspritValue (value) {
    const numericValue = +value || 1
    if (numericValue === 3) {
      return 2
    }
    return numericValue
  }

  generateCode () {
    const exterior = this.state.exterior
    const interior = this.state.interior
    const transom = this.state.transom

    const exteriorKeys = [
      'HullColorways',
      'Bowsprit',
      'HullTreatment',
      'TeakDeck',
      'TeakOnSideDecks',
      'BathingPlatform',
      'SelfTacker',
      'TeakOnCoachRoof',
      'Wheel',
      'MastAndBoom',
      'BoomCover',
      'OutboardBracket',
      'CockpitBenchExtentions',
      'CockpitCushionBackrests',
      'CockpitCushionSeats',
      'CockpitFabric',
      'SprayhoodFabric',
      'GTSeat',
      'Flag'
    ]

    const interiorKeys = [
      'PortAftCabinOptions',
      'StarboardAftCabinOptions',
      'Veneer',
      'Floorboard',
      'Worktop',
      'StarboardAftCabin',
      'FabricSaloon',
      'CupboardsOwnersCabin',
      'Mast',
      'TableBox',
      'Pouffes',
      'FabricCabins'
    ]

    const data = [
      'X46MK2',
      exteriorKeys.map(key =>
        key === 'BathingPlatform'
          ? this.getBathingPlatformCodeValue(exterior.BathingPlatform)
          : exterior[key].value
      ),
      [
        [
          transom.Name.value,
          transom.Name.font.value,
          transom.Name.size.value,
          transom.Name.color.value,
          transom.Name.horizontalOffset,
          transom.Name.verticalOffset
        ],
        [
          transom.Port.value,
          transom.Port.font.value,
          transom.Port.size.value,
          transom.Port.color.value,
          transom.Port.horizontalOffset,
          transom.Port.verticalOffset
        ]
      ],
      interiorKeys.map(key => interior[key].value)
    ]

    return btoa(JSON.stringify(data))
  }

  parseCode (code) {
    let json = JSON.parse(atob(code))

    if (json[0] !== 'X46MK2') {
      return
    }

    // See generateCode for schema and index order.
    const ext = json[1]
    const exterior = this.state.exterior

    if (ext.length >= 22) {
      exterior.HullColorways =
        this.HullColourOptions.find(v => v.value === ext[0]) ||
        this.HullColourOptions[0]
      exterior.Bowsprit =
        this.BowSpritOptions.find(
          v => v.value === this.migrateBowspritValue(ext[1])
        ) || this.BowSpritOptions[0]
      exterior.HullTreatment =
        this.HullTreatmentOptions.find(v => v.value === ext[2]) ||
        this.HullTreatmentOptions[0]
      exterior.TeakDeck =
        this.DeckOptions.find(v => v.value === ext[3]) || this.DeckOptions[0]
      exterior.TeakOnSideDecks = { value: +ext[4] || 1, label: '' }
      exterior.BathingPlatform =
        this.BathingPlatformOptions.find(
          v => v.value === this.migrateBathingPlatformValue(ext[5])
        ) || this.BathingPlatformOptions[1]
      exterior.SelfTacker =
        this.SelfTackerOptions.find(v => v.value === ext[7]) ||
        this.SelfTackerOptions[0]
      exterior.TeakOnCoachRoof =
        this.TeakOnCoachRoofOptions.find(v => v.value === +ext[8]) ||
        this.TeakOnCoachRoofOptions[0]
      exterior.Wheel =
        this.WheelOptions.find(v => v.value === ext[9]) || this.WheelOptions[0]
      exterior.MastAndBoom =
        this.MastAndBoomOptions.find(v => v.value === ext[10]) ||
        this.MastAndBoomOptions[0]
      exterior.BoomCover =
        this.BoomCoverOptions.find(v => v.value === ext[11]) ||
        this.BoomCoverOptions[0]
      exterior.OutboardBracket =
        this.OutboardBracketOptions.find(v => v.value === ext[12]) ||
        this.OutboardBracketOptions[0]
      exterior.CockpitBenchExtentions =
        this.CockpitBenchExtentionsOptions.find(
          v => v.value === Math.min(+ext[13] || 1, 2)
        ) || this.CockpitBenchExtentionsOptions[0]
      exterior.CockpitCushionBackrests =
        this.CockpitCushionBackrestsOptions.find(v => v.value === ext[14]) ||
        this.CockpitCushionBackrestsOptions[0]
      exterior.CockpitCushionSeats =
        this.CockpitCushionSeatsOptions.find(v => v.value === ext[15]) ||
        this.CockpitCushionSeatsOptions[0]
      exterior.CockpitFabric =
        this.CockpitFabricOptions.find(v => v.value === ext[20]) ||
        this.CockpitFabricOptions[0]
      exterior.SprayhoodFabric =
        this.SprayhoodOptions.find(v => v.value === ext[17]) ||
        this.SprayhoodOptions[0]
      exterior.GTSeat =
        this.GTSeatOptions.find(v => v.value === Math.min(+ext[19] || 1, 2)) ||
        this.GTSeatOptions[0]
      exterior.Flag =
        this.FlagOptions.find(v => v.value === ext[21]) || this.FlagOptions[0]
    } else if (ext.length >= 19) {
      exterior.HullColorways =
        this.HullColourOptions.find(v => v.value === ext[0]) ||
        this.HullColourOptions[0]
      exterior.Bowsprit =
        this.BowSpritOptions.find(
          v => v.value === this.migrateBowspritValue(ext[1])
        ) || this.BowSpritOptions[0]
      exterior.HullTreatment =
        this.HullTreatmentOptions.find(v => v.value === ext[2]) ||
        this.HullTreatmentOptions[0]
      exterior.TeakDeck =
        this.DeckOptions.find(v => v.value === ext[3]) || this.DeckOptions[0]
      exterior.TeakOnSideDecks = { value: +ext[4] || 1, label: '' }
      exterior.BathingPlatform =
        this.BathingPlatformOptions.find(
          v => v.value === this.migrateBathingPlatformValue(ext[5])
        ) || this.BathingPlatformOptions[1]
      exterior.SelfTacker =
        this.SelfTackerOptions.find(v => v.value === ext[6]) ||
        this.SelfTackerOptions[0]
      exterior.TeakOnCoachRoof =
        this.TeakOnCoachRoofOptions.find(v => v.value === +ext[7]) ||
        this.TeakOnCoachRoofOptions[0]
      exterior.Wheel =
        this.WheelOptions.find(v => v.value === ext[8]) || this.WheelOptions[0]
      exterior.MastAndBoom =
        this.MastAndBoomOptions.find(v => v.value === ext[9]) ||
        this.MastAndBoomOptions[0]
      exterior.BoomCover =
        this.BoomCoverOptions.find(v => v.value === ext[10]) ||
        this.BoomCoverOptions[0]
      exterior.OutboardBracket =
        this.OutboardBracketOptions.find(v => v.value === ext[11]) ||
        this.OutboardBracketOptions[0]
      exterior.CockpitBenchExtentions =
        this.CockpitBenchExtentionsOptions.find(
          v => v.value === Math.min(+ext[12] || 1, 2)
        ) || this.CockpitBenchExtentionsOptions[0]
      exterior.CockpitCushionBackrests =
        this.CockpitCushionBackrestsOptions.find(v => v.value === ext[13]) ||
        this.CockpitCushionBackrestsOptions[0]
      exterior.CockpitCushionSeats =
        this.CockpitCushionSeatsOptions.find(v => v.value === ext[14]) ||
        this.CockpitCushionSeatsOptions[0]
      exterior.CockpitFabric =
        this.CockpitFabricOptions.find(v => v.value === ext[15]) ||
        this.CockpitFabricOptions[0]
      exterior.SprayhoodFabric =
        this.SprayhoodOptions.find(v => v.value === ext[16]) ||
        this.SprayhoodOptions[0]
      exterior.GTSeat =
        this.GTSeatOptions.find(v => v.value === ext[17]) ||
        this.GTSeatOptions[0]
      exterior.Flag =
        this.FlagOptions.find(v => v.value === ext[18]) || this.FlagOptions[0]
    } else {
      exterior.HullColorways =
        this.HullColourOptions.find(v => v.value === ext[0]) ||
        this.HullColourOptions[0]
      exterior.Bowsprit =
        this.BowSpritOptions.find(
          v => v.value === this.migrateBowspritValue(ext[1])
        ) || this.BowSpritOptions[0]
      exterior.HullTreatment =
        this.HullTreatmentOptions.find(v => v.value === ext[2]) ||
        this.HullTreatmentOptions[0]
      exterior.TeakDeck =
        this.DeckOptions.find(v => v.value === ext[3]) || this.DeckOptions[0]
      exterior.TeakOnSideDecks = { value: +ext[4] || 1, label: '' }
      exterior.TeakOnCoachRoof =
        this.TeakOnCoachRoofOptions.find(v => v.value === +ext[5]) ||
        this.TeakOnCoachRoofOptions[0]
      exterior.BathingPlatform =
        this.BathingPlatformOptions.find(
          v => v.value === this.migrateBathingPlatformValue(ext[6])
        ) || this.BathingPlatformOptions[1]
      exterior.SprayhoodFabric =
        this.SprayhoodOptions.find(v => v.value === ext[9]) ||
        this.SprayhoodOptions[0]
      exterior.Wheel =
        this.WheelOptions.find(v => v.value === ext[10]) || this.WheelOptions[0]
      exterior.MastAndBoom =
        this.MastAndBoomOptions.find(v => v.value === ext[11]) ||
        this.MastAndBoomOptions[0]
      exterior.BoomCover =
        this.BoomCoverOptions.find(v => v.value === ext[12]) ||
        this.BoomCoverOptions[0]
    }

    const transom = this.state.transom
    transom.Name.value = json[2][0][0] || ''
    transom.Name.font =
      this.fontOptions.find(v => v.value === json[2][0][1]) ||
      this.fontOptions[0]
    transom.Name.size =
      this.sizeOptions.find(v => v.value === json[2][0][2]) ||
      this.sizeOptions[0]
    transom.Name.color =
      this.colorOptions.find(v => v.value === json[2][0][3]) ||
      this.colorOptions[0]
    transom.Name.horizontalOffset = +json[2][0][4] || 0
    transom.Name.verticalOffset = +json[2][0][5] || 0

    transom.Port.value = json[2][1][0] || ''
    transom.Port.font =
      this.fontOptions.find(v => v.value === json[2][1][1]) ||
      this.fontOptions[0]
    transom.Port.size =
      this.sizeOptions.find(v => v.value === json[2][1][2]) ||
      this.sizeOptions[0]
    transom.Port.color =
      this.colorOptions.find(v => v.value === json[2][1][3]) ||
      this.colorOptions[0]
    transom.Port.horizontalOffset = +json[2][1][4] || 0
    transom.Port.verticalOffset = +json[2][1][5] || 0

    const int = json[3]
    const interior = this.state.interior

    if (int.length >= 12) {
      interior.PortAftCabinOptions =
        this.PortAftCabinOptions.find(v => v.value === int[0]) ||
        this.PortAftCabinOptions[0]
      interior.StarboardAftCabinOptions =
        this.StarboardAftCabinOptions.find(v => v.value === int[1]) ||
        this.StarboardAftCabinOptions[0]
      interior.Veneer =
        this.VeneerOptions.find(v => v.value === int[2]) ||
        this.VeneerOptions[0]
      interior.Floorboard =
        this.FloorboardOptions.find(v => v.value === int[3]) ||
        this.FloorboardOptions[0]
      interior.Worktop =
        this.WorktopOptions.find(v => v.value === int[4]) ||
        this.WorktopOptions[0]
      interior.StarboardAftCabin =
        this.StarboardAftCabinBerthOptions.find(v => v.value === int[5]) ||
        this.StarboardAftCabinBerthOptions[0]
      interior.FabricSaloon =
        this.FabricSaloonOptions.find(v => v.value === int[6]) ||
        this.FabricSaloonOptions[0]
      interior.CupboardsOwnersCabin = { value: +int[7] || 1, label: '' }
      interior.Mast =
        this.MastAndBoomOptions.find(v => v.value === int[8]) ||
        exterior.MastAndBoom
      interior.TableBox = { value: +int[9] || 1, label: '' }
      interior.Pouffes = { value: +int[10] || 1, label: '' }
      interior.FabricCabins =
        this.FabricCabinsOptions.find(v => v.value === int[11]) ||
        this.FabricCabinsOptions[0]
    } else if (int.length >= 13) {
      const shelvingValue = +int[12] || 1
      const shelvingOption =
        this.PortAftCabinOptions.find(v => v.value === shelvingValue) ||
        this.PortAftCabinOptions[0]

      interior.PortAftCabinOptions = shelvingOption
      interior.StarboardAftCabinOptions =
        this.StarboardAftCabinOptions.find(v => v.value === shelvingValue) ||
        this.StarboardAftCabinOptions[0]
      interior.Veneer =
        this.VeneerOptions.find(v => v.value === int[0]) ||
        this.VeneerOptions[0]
      interior.Floorboard =
        this.FloorboardOptions.find(v => v.value === int[1]) ||
        this.FloorboardOptions[0]
      interior.Worktop =
        this.WorktopOptions.find(v => v.value === int[2]) ||
        this.WorktopOptions[0]
      interior.StarboardAftCabin =
        this.StarboardAftCabinBerthOptions.find(v => v.value === int[3]) ||
        this.StarboardAftCabinBerthOptions[0]
      interior.FabricSaloon =
        this.FabricSaloonOptions.find(v => v.value === int[4]) ||
        this.FabricSaloonOptions[0]
      interior.CupboardsOwnersCabin = { value: +int[6] || 1, label: '' }
      interior.Mast =
        this.MastAndBoomOptions.find(v => v.value === int[7]) ||
        exterior.MastAndBoom
      interior.TableBox = { value: +int[9] || 1, label: '' }
      interior.Pouffes = { value: +int[10] || 1, label: '' }
      interior.FabricCabins =
        this.FabricCabinsOptions.find(v => v.value === int[11]) ||
        this.FabricCabinsOptions[0]
    } else {
      interior.PortAftCabinOptions = this.PortAftCabinOptions[0]
      interior.StarboardAftCabinOptions = this.StarboardAftCabinOptions[0]
      interior.Veneer =
        this.VeneerOptions.find(v => v.value === int[0]) ||
        this.VeneerOptions[0]
      interior.Floorboard =
        this.FloorboardOptions.find(v => v.value === int[1]) ||
        this.FloorboardOptions[0]
      interior.Worktop =
        this.WorktopOptions.find(v => v.value === int[2]) ||
        this.WorktopOptions[0]
      interior.FabricSaloon =
        this.FabricSaloonOptions.find(v => v.value === int[3]) ||
        this.FabricSaloonOptions[0]
      interior.CupboardsOwnersCabin = { value: +int[5] || 1, label: '' }
      interior.StarboardAftCabin =
        this.StarboardAftCabinBerthOptions.find(v => v.value === int[6]) ||
        this.StarboardAftCabinBerthOptions[0]
      interior.TableBox = { value: +int[8] || 1, label: '' }
      interior.Pouffes = { value: +int[9] || 1, label: '' }
      interior.FabricCabins =
        this.FabricCabinsOptions.find(v => v.value === int[10]) ||
        this.FabricCabinsOptions[0]
      interior.Mast =
        this.MastAndBoomOptions.find(
          v => v.value === int[int.length >= 14 ? 13 : 12]
        ) || exterior.MastAndBoom
    }

    this.setState({
      ...this.state,
      interior: normalizeX46MK2InteriorConfiguration(interior)
    })
  }

  renderSteps () {
    return (
      <Switch location={this.props.location}>
        <Route
          exact
          path='/x46mk2'
          render={() => <Redirect to='/x46mk2/hull' />}
        />

        <Route
          path='/x46mk2/hull'
          render={props => (
            <X46MK2Hull
              {...props}
              onChange={this.handleHullConfigurationChange}
              onCodeSubmitted={this.parseCode}
              configuration={this.state.exterior}
              transom={this.state.transom}
              hullColourOptions={this.HullColourOptions}
            />
          )}
        />
        <Route
          path='/x46mk2/allexterioroptions'
          render={props => (
            <X46MK2AllExteriorOptions
              {...props}
              onChange={this.handleHullConfigurationChange}
              configuration={this.state.exterior}
              transom={this.state.transom}
              hullColourOptions={this.HullColourOptions}
              bowSpritOptions={this.BowSpritOptions}
              hullTreatmentOptions={this.HullTreatmentOptions}
              teakDeckOptions={this.DeckOptions}
              teakOnSideDecksOptions={this.TeakOnSideDecksOptions}
              bathingPlatformOptions={this.BathingPlatformOptions}
              selfTackerOptions={this.SelfTackerOptions}
              teakOnCoachRoofOptions={this.TeakOnCoachRoofOptions}
              wheelOptions={this.WheelOptions}
              mastAndBoomOptions={this.MastAndBoomOptions}
              boomCoverOptions={this.BoomCoverOptions}
              outboardBracketOptions={this.OutboardBracketOptions}
              cockpitBenchExtentionsOptions={this.CockpitBenchExtentionsOptions}
              cockpitCushionBackrestsOptions={
                this.CockpitCushionBackrestsOptions
              }
              cockpitCushionSeatsOptions={this.CockpitCushionSeatsOptions}
              cockpitFabricOptions={this.CockpitFabricOptions}
              sprayhoodOptions={this.SprayhoodOptions}
              gtSeatOptions={this.GTSeatOptions}
              flagOptions={this.FlagOptions}
            />
          )}
        />
        <Route
          path='/x46mk2/bowsprit'
          render={props => (
            <X46MK2BowSprit
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              bowSpritOptions={this.BowSpritOptions}
            />
          )}
        />
        <Route
          path='/x46mk2/hulltreatment'
          render={props => (
            <X46MK2HullTreatment
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              transom={this.state.transom}
              hullTreatmentOptions={this.HullTreatmentOptions}
            />
          )}
        />
        <Route
          path='/x46mk2/transom'
          render={props => (
            <X46MK2Transom
              {...props}
              onChange={this.handleTransomChange}
              configuration={this.state.exterior}
              transom={this.state.transom}
              fontOptions={this.fontOptions}
              sizeOptions={this.sizeOptions}
              colorOptions={this.colorOptions}
            />
          )}
        />
        <Route
          path='/x46mk2/deck'
          render={props => (
            <X46MK2Deck
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              transom={this.state.transom}
              deckOptions={this.DeckOptions}
            />
          )}
        />
        <Route
          path='/x46mk2/cockpit'
          render={props => (
            <X46MK2Cockpit
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              cockpitBenchExtentionsOptions={this.CockpitBenchExtentionsOptions}
              cockpitCushionBackrestsOptions={
                this.CockpitCushionBackrestsOptions
              }
              cockpitCushionSeatsOptions={this.CockpitCushionSeatsOptions}
              cockpitFabricOptions={this.CockpitFabricOptions}
              outboardBracketOptions={this.OutboardBracketOptions}
              gtSeatOptions={this.GTSeatOptions}
            />
          )}
        />
        <Route
          path='/x46mk2/bathingplatform'
          render={props => (
            <X46MK2BathingPlatform
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              transom={this.state.transom}
              configuration={this.state.exterior}
              bathingPlatformOptions={this.BathingPlatformOptions}
            />
          )}
        />
        <Route
          path='/x46mk2/sprayhood'
          render={props => (
            <X46MK2Sprayhood
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              transom={this.state.transom}
              sprayhoodOptions={this.SprayhoodOptions}
              boomCoverOptions={this.BoomCoverOptions}
            />
          )}
        />
        <Route
          path='/x46mk2/wheel'
          render={props => (
            <X46MK2Wheel
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              wheelOptions={this.WheelOptions}
            />
          )}
        />
        <Route
          path='/x46mk2/mast'
          render={props => (
            <X46MK2Mast
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              transom={this.state.transom}
              mastAndBoomOptions={this.MastAndBoomOptions}
              selfTackerOptions={this.SelfTackerOptions}
            />
          )}
        />

        <Route
          path='/x46mk2/surfaces'
          render={props => (
            <X46MK2Interior
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              configuration={this.state.interior}
              veneerOptions={this.VeneerOptions}
              floorboardOptions={this.FloorboardOptions}
            />
          )}
        />
        <Route
          path='/x46mk2/saloon'
          render={props => (
            <X46MK2Saloon
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              configuration={this.state.interior}
            />
          )}
        />
        <Route
          path='/x46mk2/fabric'
          render={props => (
            <X46MK2Fabric
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              configuration={this.state.interior}
              fabricSaloonOptions={this.FabricSaloonOptions}
            />
          )}
        />
        <Route
          path='/x46mk2/galley'
          render={props => (
            <X46MK2Galley
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              configuration={this.state.interior}
              worktopOptions={this.WorktopOptions}
            />
          )}
        />
        <Route
          path='/x46mk2/aftcabin'
          render={props => (
            <X46MK2AftCabin
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              fabricCabinsOptions={this.FabricCabinsOptions}
              configuration={this.state.interior}
              portAftCabinOptions={this.PortAftCabinOptions}
            />
          )}
        />
        <Route
          path='/x46mk2/starboardaftcabin'
          render={props => (
            <X46MK2StarboardAftCabin
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              fabricCabinsOptions={this.FabricCabinsOptions}
              configuration={this.state.interior}
              starboardAftCabinOptions={this.StarboardAftCabinOptions}
            />
          )}
        />
        <Route
          path='/x46mk2/ownerscabin'
          render={props => (
            <X46MK2OwnersCabin
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              fabricCabinsOptions={this.FabricCabinsOptions}
              configuration={this.state.interior}
            />
          )}
        />
        <Route
          path='/x46mk2/heads'
          render={props => (
            <X46MK2Heads {...props} configuration={this.state.interior} />
          )}
        />

        <Route
          path='/x46mk2/summary'
          render={props => (
            <X46MK2Summary
              {...props}
              country={this.state.country}
              countries={this.state.countries}
              code={this.generateCode()}
              configuration={{
                exterior: this.state.exterior,
                interior: this.state.interior,
                transom: this.state.transom
              }}
            />
          )}
        />
      </Switch>
    )
  }
}

export default withTranslation()(X46MK2Container)



// WEBPACK FOOTER //
// ./src/X46MK2/X46MK2Container.js